import axios from "axios";
import { APIConstants } from "../../constants/ApiConstants";
import { PermissionUpdateProps } from "../../components/AccessManagement/PermissionProps";

export const getUserRoles = async () => {
  try {
    const url = `${process.env.REACT_APP_API_URL}${APIConstants.role}`;
    const users = await axios.get(url);
    const userData = users?.data.data;
    return userData;
  } catch (error) {
    console.error("error", error);
    return null;
  }
};

export const getRolePermissions = async (role: string) => {
  const url = `${process.env.REACT_APP_API_URL}${APIConstants.getRolePermission}${role}`;
  try {
    const users = await axios.get(url);
    return users?.data;
  } catch (err) {
    console.error(err);
  }
};
export const getMasterRoles = async (role: string) => {
  const url = `${process.env.REACT_APP_API_URL}${APIConstants.getMasterPermissions}${role}`;
  try {
    const users = await axios.get(url);
    return users?.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const updateMasterPermisison = async (data: PermissionUpdateProps) => {
  const url = `${process.env.REACT_APP_API_URL}${APIConstants.updateRolePermissions}`;
  try {
    const users = await axios.patch(url, data);
    return users?.data;
  } catch (error) {
    return null;
  }
};
